import React from 'react';
import ReactDOM from 'react-dom/client';
import { Layout } from './layout';

const el = document.getElementById('react-app');

if (el) {
	ReactDOM.createRoot(el).render(<Layout />);
}
